import React from 'react'
import Sidebar from '../../../Sidebar'
import Navbar from '../../../Navbar'

const AddVoterRegistrMsg = () => {
  return (
    <>
      <Sidebar/>
        <div className="main">
          <div className="topbar">
            <Navbar title="Add Voter Registration Message"/>
          </div>
        </div>
    </>
  )
}

export default AddVoterRegistrMsg
